<script lang="ts" setup>
import NotificationAddToCart from './NotificationAddToCart.vue'
import { PrescriptionVariant } from '@/models/prescription'

const props = defineProps<{
  quantity: number
  variant: PrescriptionVariant
}>()

const FileSvg = useUrlResource('icon-file.svg')
const QRCodeSvg = useUrlResource('qr-code.svg')

const { t } = useTranslation()

const image = computed(() => {
  switch (props.variant) {
    case 'ePrescription':
      return QRCodeSvg.value
    case 'prescription':
      return FileSvg.value
    default:
      return ''
  }
})

const item = computed(() => {
  switch (props.variant) {
    case PrescriptionVariant.ONLINE:
      return t('prescriptionUpload.item.ePrescription')
    case PrescriptionVariant.REGULAR:
      return t('prescriptionUpload.item.prescription')
    default:
      return ''
  }
})
</script>

<template>
  <NotificationAddToCart
    :quantity="quantity"
    :item="item"
    :image="image"
    variant="prescription"
  />
</template>
